import { MULTI_SELLER_TREATMENT_VARIANT } from 'shared/constants/multiSeller';

type MultiSellerSurface = 'pdp' | 'cart';

interface MultiSellerConfig {
  enabled?: boolean;
  pdp?: { enabled?: boolean };
  cart?: { enabled?: boolean };
}

export const isMultiSellerEligible = ({
  multiSellerEnabled,
  multiSellerConfig,
  isEligible,
  variant,
  surface,
}: {
  multiSellerEnabled: boolean;
  multiSellerConfig?: MultiSellerConfig;
  isEligible: boolean;
  variant?: string;
  surface: MultiSellerSurface;
}) =>
  Boolean(
    multiSellerEnabled &&
      multiSellerConfig?.enabled &&
      multiSellerConfig?.[surface]?.enabled &&
      isEligible &&
      variant === MULTI_SELLER_TREATMENT_VARIANT
  );

export const getSelectedVendorId = (
  selectedSKU?: { vendor_id?: string },
  defaultVendorId?: string
) => selectedSKU?.vendor_id || defaultVendorId || '';

export const resolveVendorId = <T>(
  vendors: Record<string, T> = {},
  selectedVendorId = '',
  defaultVendorId = ''
) => {
  if (selectedVendorId && vendors[selectedVendorId]) return selectedVendorId;
  if (defaultVendorId && vendors[defaultVendorId]) return defaultVendorId;

  return selectedVendorId || defaultVendorId;
};
